/**
 * Created by A665445 on 09/05/2017.
 */
import { Injectable } from '@angular/core';
import { Http, Response} from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {MasterProposal} from './master-proposal.model';
import { Saisine } from '../saisine/saisine.model';
import 'rxjs/add/operator/map';

/**
 *
 * MasterProposalService
 */
@Injectable()
export class MasterProposalService {

    private resourceInterneUrl = 'api/interne/master-proposals';
    private resourceStudentUrl = 'api/student-saisine';
    private resourceInterneSaisineUrl = 'api/interne/saisines';

    constructor(private http: Http) {
    }

    update(masterProposal: MasterProposal): Observable<MasterProposal> {
        let copy: MasterProposal = Object.assign({}, masterProposal);
        return this.http.put(this.resourceInterneUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    updateMPToConfirmed(saisineId: number, masterProposal): Observable<MasterProposal> {
        return this.http.put(`${this.resourceStudentUrl}/${saisineId}/master-proposals/${masterProposal.id}/confirm`, null).map((res: Response) => {
            return res.json() as MasterProposal;
        });
    }

    updateMPToRefused(saisineId: number, masterProposal): Observable<MasterProposal> {
        return this.http.put(`${this.resourceStudentUrl}/${saisineId}/master-proposals/${masterProposal.id}/refuse`, null).map((res: Response) => {
            return res.json() as MasterProposal;
        });
    }

    updateMPToTransmitted(saisineId: number, masterProposals: MasterProposal[]): Observable<Saisine> {
        return this.http.put(`${this.resourceInterneSaisineUrl}/${saisineId}/master-proposals/transmit`, masterProposals).map((res: Response) => {
            return res.json() as Saisine;
        });
    }

    masterProposalsAccept( saisineId: number, masterProposal ): Observable<Saisine> {
        return this.http.put(`${this.resourceInterneSaisineUrl}/${saisineId}/master-proposals/${masterProposal.id}/accept`, masterProposal).map((res: Response) => {
            return res.json();
        });
    }
    masterProposalsReject(saisineId: number, masterProposal ): Observable<Saisine> {
        return this.http.put(`${this.resourceInterneSaisineUrl}/${saisineId}/master-proposals/${masterProposal.id}/reject`, masterProposal).map((res: Response) => {
            return res.json();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master-proposal/master-proposal.service.ts